import React from 'react';

export const UploadImage = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 8.25H12l-3-3-3 3h2.25v7.5h1.5v-7.5zM3 2.25v1.5h12v-1.5H3z"
        fill="#000"
      />
    </svg>
  );
};

export const SelectedImageIcon = ({ color }: { color: string }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
      <circle cx="11.5" cy="11.5" r="11.5" fill={color} />
      <g clipPath="url(#clip0_492_47413)">
        <mask
          id="mask0_492_47413"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="6"
          width="15"
          height="11"
        >
          <path
            d="M9.68421 14.6007L6.85965 11.6675C6.54491 11.3407 6.04456 11.3407 5.72983 11.6675C5.41509 11.9944 5.41509 12.514 5.72983 12.8408L9.11123 16.3523C9.42597 16.6791 9.93439 16.6791 10.2491 16.3523L18.8035 7.47725C19.1182 7.15041 19.1182 6.63081 18.8035 6.30397C18.4888 5.97713 17.9884 5.97713 17.6737 6.30397L9.68421 14.6007Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_492_47413)">
          <path
            d="M9.68421 14.6007L6.85965 11.6675C6.54491 11.3407 6.04456 11.3407 5.72983 11.6675C5.41509 11.9944 5.41509 12.514 5.72983 12.8408L9.11123 16.3523C9.42597 16.6791 9.93439 16.6791 10.2491 16.3523L18.8035 7.47725C19.1182 7.15041 19.1182 6.63081 18.8035 6.30397C18.4888 5.97713 17.9884 5.97713 17.6737 6.30397L9.68421 14.6007Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_492_47413">
          <rect width="14.5263" height="10.8947" fill="white" transform="translate(4.8421 6.05261)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseModalIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="4.9 4.9 14 14" fill="none">
      <path
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
        fill="#000"
      />
    </svg>
  );
};

export const EyeIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6 0C5.236 0 1.51 2.813 0 6.785c1.51 3.971 5.236 6.785 9.6 6.785s8.09-2.814 9.6-6.785C17.69 2.813 13.964 0 9.6 0zm0 11.308c-2.409 0-4.364-2.026-4.364-4.523S7.191 2.262 9.6 2.262s4.364 2.026 4.364 4.523-1.955 4.523-4.364 4.523zM6.98 6.785c0-1.502 1.17-2.714 2.619-2.714 1.448 0 2.618 1.212 2.618 2.714S11.048 9.499 9.6 9.499c-1.45 0-2.619-1.212-2.619-2.714z"
        fill="#000"
        fillOpacity=".4"
      />
    </svg>
  );
};
